export default __webpack_public_path__ + "static/content-36ac8587abe6626ef915da793c1234d7.jpg";